
import {functions} from "@/scripts/firebase"
import {httpsCallable} from "firebase/functions"
import {NoticeProps} from "@/scripts/datatypes"
import {$defaultUserRole} from '@/scripts/common'
import { Component,Watch ,Mixins} from "vue-property-decorator";
import Common from '@/mixins/common'
import { ValidationObserver } from 'vee-validate'
import {toHiragana,toZenKana} from 'jaconv'
import { AddUserRes, GetUserRolesAccessLevelsRes, UserPrivateProfile, UserPublicProfile } from "@/common-datatypes"
import { ValidationFlags } from "vee-validate/dist/types/types";

@Component({
  components: {
  }
})

export default class AddUser extends Mixins(Common) {
  isLoading = false
  notice: NoticeProps = {}
  disabledAddUser = true
  userPublicProfile = {} as UserPublicProfile
  userPrivateProfile = {} as UserPrivateProfile
  userRolesAccessLevels = {} as GetUserRolesAccessLevelsRes
  telInputShowFlags = true
  phoneObject = {number: '',valid: false,formatted: ''}
  showModal = false

  showPanel = false

  @Watch('userPublicProfile',{deep: true})
  async changeUserPublicProfile(newVal: UserPublicProfile){

    if(newVal.lastNameYomigana){
      newVal.lastNameYomigana = toHiragana(toZenKana(newVal.lastNameYomigana))
      newVal.lastNameYomigana = (newVal.lastNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

    if(newVal.firstNameYomigana){
      newVal.firstNameYomigana = toHiragana(toZenKana(newVal.firstNameYomigana))
      newVal.firstNameYomigana = (newVal.firstNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }
  }

  public inputPhoneNumber(number: string, phoneObject: {number: string; valid: boolean; formatted: string}){
    this.phoneObject = phoneObject
    //this.observer.reset()
  }

  countryChanged(countryObject: {dialCode: string}){
    console.log(countryObject)
    if(this.changeCountryCount === 0 && this.observer.id){
      this.$nextTick(() => {
        this.observer.reset()
      })
    }
    this.changeCountryCount ++
  }

  changeCountryCount = 0

  mounted(){
    console.log('mounted')
  }

  updated(){
    console.log('updated')

    if( ! this.observer.flags && this.$refs.addUserValidationObserver){
      this.observer = this.$refs.addUserValidationObserver as InstanceType<typeof ValidationObserver>
    }
  }

  @Watch('observer.flags')
  changeObservserFlags(flags: ValidationFlags){
    console.log('changeFlags')
    
    this.disabledAddUser = ! flags.changed
  }

  observer = {} as InstanceType<typeof ValidationObserver>

  get defaultUserPublicProfile(){
    return {
      roles: [$defaultUserRole]
    } as UserPublicProfile
  }

  get defaultUserPrivateProfile(){
    return {
      lang: this.$store.getters.lang,
      timeZone: this.$defaultTimeZone
    } as UserPrivateProfile
  }

  async created() {
    console.trace('created')
    try{
      this.$store.commit('setLoading',true)
      this.isLoading = true
       
      const userRolesAccessLevels = await this.$getUserRolesAccessLevels(this.$store.getters.schoolId)

      this.userRolesAccessLevels = {...userRolesAccessLevels.data}
      this.userPublicProfile = {...this.defaultUserPublicProfile}
      this.userPrivateProfile = {...this.defaultUserPrivateProfile}
    }catch(error){
      //console.log(error)
    }finally{
      this.$store.commit('setLoading',false)
      this.isLoading = false
    }
  }

  get languages(): string[]{
    if(this.$i18n.availableLocales){
      return this.$i18n.availableLocales
    }
    return []
  }

  get roles(): string[]{
    const roles = Object.keys(this.userRolesAccessLevels || {})
    return roles
    /*
    return roles.sort((a,b) => {
      const uLa = this.userRolesAccessLevels[roles[a as any]]
      const uLb = this.userRolesAccessLevels[roles[b as any]]
      return uLa.accessLevel - uLb.accessLevel
    })
    */
  }

  async addUser(){
    try{
      this.notice = {
				isShow: false,
      }

      if(this.phoneObject.valid === false || ! await this.observer.validate()){
        if(this.phoneObject.valid === false){
          this.observer.setErrors({
            phoneNumber: this.$t('authentication.errorCode.auth/invalid-phone-number') as string
          })
        }
        return
      }

      const updatePublicProfile = {
        ...this.userPublicProfile
      }

      const updatePrivateProfile = {
        ...this.userPrivateProfile,
        phoneNumber: this.phoneObject.number || ''
      }

      if(Object.keys(updatePublicProfile).length > 0 || Object.keys(updatePrivateProfile).length > 0){

        this.$store.commit("setLoading",true);
        this.isLoading = true

        const addUser = httpsCallable(functions,'addUser')

        const newUser = await addUser({schoolId: this.$store.getters.schoolId}) as {data: AddUserRes}

        const newUserId = newUser.data.userId

        console.log(newUserId)

        if(Object.keys(updatePublicProfile).length > 0){
          console.log(updatePublicProfile)
          const userPublicProfileDoc = this.$getUserPublicProfileDocRef(newUserId)

          await this.$updateDoc(userPublicProfileDoc, {
            ...updatePublicProfile,
          } as UserPublicProfile)
        }

        if(Object.keys(updatePrivateProfile).length > 0){
          console.log('private')
          console.log(updatePrivateProfile)
          const userPrivateProfileDoc = this.$getUserPrivateProfileDocRef(newUserId)

          await this.$updateDoc(userPrivateProfileDoc,{
            ...updatePrivateProfile
          } as UserPrivateProfile)
        }

        this.notice = {
          message: this.$t('addUser.added') as string,
          isShow: true,
          type: {'is-success': true}
        }
        this.userPublicProfile = {...this.defaultUserPublicProfile}
        this.userPrivateProfile = {...this.defaultUserPrivateProfile}
        this.$nextTick(() => {
          this.observer.reset()
        })

      }else{
        this.notice = {
          message: this.$t('profile.noChangedFields') as string,
          isShow: true,
          type: {'is-info': true}
        }
      }

    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('addUser.error') as string
      
			const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disabledAddUser = true
    }
  }
}
